module.exports = __webpack_public_path__ + "img/scs.cab34cc1.png";